import z from 'zod';

export type AccessorySortOrder =
	| 'NameAsc'
	| 'NameDesc'
	| 'LastEditedDateAsc'
	| 'LastEditedDateDesc'
	| 'DensityAsc'
	| 'DensityDesc'
	| 'PriceAsc'
	| 'PriceDesc'
	| 'CarbonDioxideAsc'
	| 'CarbonDioxideDesc';

export const AccessorySortOrderSchema: z.ZodType<AccessorySortOrder> = z.enum([
	'NameAsc',
	'NameDesc',
	'LastEditedDateAsc',
	'LastEditedDateDesc',
	'DensityAsc',
	'DensityDesc',
	'PriceAsc',
	'PriceDesc',
	'CarbonDioxideAsc',
	'CarbonDioxideDesc',
]);
